import { ITreatment } from "../../types/models/Treatment";
import styles from "./TreatmentTable.module.css";
import EditIcon from "../../components/icons/EditIcon";
import DeleteIcon from "../../components/icons/DeleteIcon";
import IconButton from "./IconButton";

interface IProps {
    handleClick: (args: { actionType: string, treatment: ITreatment}) => void
    treatment: ITreatment,
    showButtonText: boolean
}

const ActionButtons: React.FC<IProps> = ({ treatment, showButtonText, handleClick }) => {

    return (
        <div className = {styles.action_buttons}> 
            <IconButton 
                customClassName="edit_icon_button"
                buttonText = {showButtonText ? "Edit" : ""}
                icon = {<EditIcon />}
                handleClick={handleClick}
                args = {{ actionType: "Edit", treatment }}
            />
            <IconButton 
                customClassName="delete_icon_button"
                buttonText = {showButtonText ? "Delete" : ""}
                icon = {<DeleteIcon />}
                handleClick={handleClick}
                args = {{ actionType: "Delete", treatment }}
            />
        </div>            
    );

}

export default ActionButtons;